module.exports = __webpack_public_path__ + "img/add_icon.c4096dc1.svg";